export default __webpack_public_path__ + "static/media/checkout-close.aad5acc4.svg";